import { LayoutGrid } from 'lucide-react';

interface Props {
  onClick: () => void;

  disabled?: boolean;
}

const POSCategoryMoreButton = ({ onClick, disabled }: Props) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="
        inline-flex
        h-[42px]
        items-center
        gap-2

        rounded-xl

        border

        border-slate-300
        bg-white

        px-4

        text-sm
        font-medium

        text-slate-600

        shadow-1

        transition-all
        duration-200

        hover:border-primary/50
        hover:bg-primary/10
        hover:text-primary
        hover:shadow-2

        disabled:cursor-not-allowed
        disabled:opacity-50

        dark:border-form-strokedark
        dark:bg-boxdark-2
        dark:text-bodydark2

        dark:hover:border-primary/50
        dark:hover:bg-primary/15
        dark:hover:text-primary
      "
    >
      <LayoutGrid
        className="
          h-4
          w-4

          text-primary

          transition-colors
          duration-200
        "
      />

      <span>Más</span>
    </button>
  );
};

export default POSCategoryMoreButton;
